import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateEndScreenSettingMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  input: Types.UpdateEndScreenSettingInput;
}>;


export type UpdateEndScreenSettingMutation = { __typename?: 'RootMutationType', updateEndScreenSetting?: { __typename?: 'EndScreenSettingResult', endScreenSetting?: { __typename?: 'EndScreenSetting', id: string, databaseId: any, title?: string | null, content?: string | null, textColor: string, blurEffect: number, bgType: Types.BackgroundType, bgGradientType: Types.GradientType, bgGradientAngle: number, showCta: boolean, ctaText?: string | null, ctaUrl?: string | null, ctaBgColor?: string | null, ctaTextColor?: string | null, bgImageUpload?: { __typename?: 'ImageUpload', id: string, imageUrl?: string | null } | null, colors: Array<{ __typename?: 'Color', r: number, g: number, b: number, a: number, hex: string }> } | null, userErrors?: Array<{ __typename?: 'UserError', field: string, message: string }> | null } | null };


export const UpdateEndScreenSettingDocument = gql`
    mutation updateEndScreenSetting($id: ID!, $input: UpdateEndScreenSettingInput!) {
  updateEndScreenSetting(id: $id, input: $input) {
    endScreenSetting {
      id
      databaseId
      title
      content
      textColor
      blurEffect
      bgType
      bgGradientType
      bgGradientAngle
      bgImageUpload {
        id
        imageUrl
      }
      colors {
        r
        g
        b
        a
        hex
      }
      showCta
      ctaText
      ctaUrl
      ctaBgColor
      ctaTextColor
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export type UpdateEndScreenSettingMutationFn = Apollo.MutationFunction<UpdateEndScreenSettingMutation, UpdateEndScreenSettingMutationVariables>;

/**
 * __useUpdateEndScreenSettingMutation__
 *
 * To run a mutation, you first call `useUpdateEndScreenSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEndScreenSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEndScreenSettingMutation, { data, loading, error }] = useUpdateEndScreenSettingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEndScreenSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEndScreenSettingMutation, UpdateEndScreenSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEndScreenSettingMutation, UpdateEndScreenSettingMutationVariables>(UpdateEndScreenSettingDocument, options);
      }
export type UpdateEndScreenSettingMutationHookResult = ReturnType<typeof useUpdateEndScreenSettingMutation>;
export type UpdateEndScreenSettingMutationResult = Apollo.MutationResult<UpdateEndScreenSettingMutation>;
export type UpdateEndScreenSettingMutationOptions = Apollo.BaseMutationOptions<UpdateEndScreenSettingMutation, UpdateEndScreenSettingMutationVariables>;